// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mosaic-select-layout ul li{width:49%;text-align:center;margin-bottom:25px}.mosaic-select-layout ul li a p:first-child{font-weight:bold}`, "",{"version":3,"sources":["webpack://./resources/ploud.css"],"names":[],"mappings":"AAAA,4BACI,SAAA,CACA,iBAAA,CACA,kBAAA,CAEJ,4CACI,gBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
